import React from 'react';
import PaidmrReport from '../PaidmrReport';

export default function ReportPaidmr({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("report-challan")){
    return;}
  return (
    <div className="page-challan">
        <PaidmrReport sessionObject={sessionObject}/>
    </div>
  );
}
